import { Link } from "react-router-dom";
import { useAuth } from "@clerk/react-router";
import { Logo } from "./Logo";
import { Twitter, Facebook, Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  const { isSignedIn } = useAuth();
  
  return (
    <footer className="border-t border-[var(--outline)]/30 bg-[var(--surface-container)] mt-auto pb-20 md:pb-0">
      <div className="container mx-auto px-4 md:px-6 py-8 md:py-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 md:gap-8">
          {/* Left side - Logo and Social Icons */}
          <div className="flex items-center gap-6 justify-center md:justify-start">
            <Link to={isSignedIn ? "/dashboard" : "/"} className="flex items-center">
              <Logo variant="small" className="h-8 w-auto" />
            </Link>
            <div className="flex items-center gap-4">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Right side - Links */}
          <nav className="flex flex-wrap gap-6 md:gap-8 justify-center md:justify-start">
            <Link
              to="/about"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              About
            </Link>
            <Link
              to="/method"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Method
            </Link>
            <Link
              to="/terms"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms
            </Link>
            <Link
              to="/security"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Security
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}

